module.exports = require("regenerator-runtime");


//////////////////
// WEBPACK FOOTER
// external "regenerator-runtime"
// module id = 500
// module chunks = 0